import store from "utils/store.js";

export default function setBanner(image) {
  store.dispatch({
    type: "banner/setImage",
    payload: image,
  });
}
